var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 29",
    style: {
      enableBackground: "new 0 0 30 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3F5D89;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,0.9c-2.9,0-5.8,0.9-8.4,2.6C6.2,3.8,6,4.4,6.3,4.9c0.3,0.5,0.9,0.6,1.4,0.3C7.9,5,8.1,4.9,8.3,4.8 c0.1-0.1,0.3-0.2,0.4-0.2c0.2-0.1,0.4-0.2,0.6-0.3c0,0,0.1,0,0.1-0.1C10,4,10.4,3.7,11.2,3.7c1.4,0,2.5,1.1,2.5,2.5 s-1.1,2.5-2.5,2.5c-0.8,0-1.5-0.4-1.9-0.9c-1.3,0.9-2.3,1.9-3,3.1c0.1,0,0.2,0,0.3,0C7.9,10.9,9,12,9,13.4s-1.1,2.5-2.5,2.5 c-0.6,0-1.2-0.2-1.6-0.6c0,0.3-0.1,0.6-0.1,0.9c0,4.7,3.1,8.7,7.5,9.9C6.6,25.6,2,20.8,2,15c0-0.9,0.1-1.8,0.4-2.6 c0-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.1-0.5,0.2-0.7c0-0.1,0-0.1,0.1-0.2c0.5-1.2,1.2-2.3,2-3.4c0.4-0.4,0.3-1.1-0.1-1.4 C4.2,6,3.6,6.1,3.3,6.5C1.2,9,0,12,0,15c0,7.2,5.9,13.1,13.1,13.1c4.6,0,7.5-2.2,7.5-5.7c0-1.9,1.4-2.7,3.8-3.7 c2.5-1.1,5.5-2.5,5.5-6.5C30,4.9,22.3,0.9,15,0.9z M24.5,14.9c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5S27,11,27,12.4 S25.9,14.9,24.5,14.9z M19.5,3.9C20.9,3.9,22,5,22,6.4s-1.1,2.5-2.5,2.5S17,7.8,17,6.4S18.1,3.9,19.5,3.9z M10,21.5 c0-1.5,1.6-2.6,3.5-2.6s3.5,1.2,3.5,2.6s-1.6,2.6-3.5,2.6S10,23,10,21.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkinIcon);
export default __webpack_public_path__ + "static/media/skin-icon.b2e31c688430e0e654ca7ea3c28913ff.svg";
export { ForwardRef as ReactComponent };